export default {
  notilogin: "Login attempted from new device",
  notiwithdraw: "You have successfully withdrawn",
  notideposit: "You have received ",
  notiexchange: "Exchange successfully executed",
};
